import { render } from "./versionCodeReview.vue?vue&type=template&id=0757a3dd&scoped=true"
import script from "./versionCodeReview.js?vue&type=script&lang=js"
export * from "./versionCodeReview.js?vue&type=script&lang=js"

import "./versionCodeReview.vue?vue&type=style&index=0&id=0757a3dd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0757a3dd"]])

export default __exports__